import { IPageContent } from '../../interfaces/common/content/page-content.interface';

export class PageContent implements IPageContent {
  id = 0;
  description = 'DEFAULT';
  displayText = '';
  pageStateIds = '';
  enumRef = -1;
}
